import { Colors } from '../../consts/Colors.js';
import FONTS from '../../consts/Fonts.js';
import { tags } from '../../consts/Tags.js';
import ButtonRounded from '../../prefabs/global/buttons/ButtonRounded.js';
import PopUpBlue from '../../prefabs/global/popup/PopUpBlue.js';
import SoundManager from '../../prefabs/SoundManager.js';
import AbstractScene from '../AbstractScene.js';

export default class DebutChapitre5 extends AbstractScene {

    constructor() {
        super({
            key: "DebutChapitre5"
        })
    }
    init(data){
        this._init(data);   

        this.soundManager = new SoundManager();
        this.soundManager.stopAllLoops()
        this.soundManager.playAudio('RewardsOfRisk');
    }   

    preload() {
        this._preload();
    }

    create() {
        // Ajout fond
        let background = this.add.image(0, 0, 'Chapitre5_transition_background').setOrigin(0);

        this.introGroup = this.add.group()

        let backgroundText = this.add.image(this.width/2, 140, 'Chapitre5_transition_background_text').setOrigin(0.5, 0);
        backgroundText.setAlpha(0)
        this.introGroup.add(backgroundText)

        // Ajout num chapitre
        let numChapitre = this.add.text(1162, 170, 'CHAPITRE FINAL',{
            fontSize: '18px',
            fontFamily: FONTS.Inter18Light,
            color: Colors.Text.White,
            letterSpacing:5,
            shadow: {
                offsetX: 0,
                offsetY: 8,
                color: Colors.Text.White,
                blur: 16
            }
        }).setOrigin(0)
        numChapitre.setAlpha(0)
        this.introGroup.add(numChapitre)

        // Ajout titre
        let titre1 = this.add.text(612, 163, 'Bienvenue à', {
            fontSize: '30px',
            fontFamily: FONTS.AdobeJenson,
            fontStyle: '700',
            resolution: 1.2,
            color: Colors.Text.White
        }).setOrigin(0)
        titre1.setAlpha(0)
        this.introGroup.add(titre1)

        let titre2 = this.add.text(this.width/2, 170, 'GENÈVE', {
            fontSize: '170px',
            fontFamily: FONTS.Corsario,
            color: Colors.Text.White,
            resolution: 1.2,
            letterSpacing: 7
        }).setOrigin(0.5, 0)
        titre2.setAlpha(0)
        this.introGroup.add(titre2)

        let perso = this.add.image(1349, this.height, 'Chapitre5_transition_perso').setOrigin(0, 1);
        perso.setAlpha(0)
        this.introGroup.add(perso)

        // Ajout transitions

        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        this.tweens.add({
            targets: rect,
            alpha: 0,
            duration: 1000,
            onComplete: () => {
                rect.destroy();
                
            }
        })

        this.tweens.add({
            targets: [numChapitre, backgroundText],
            alpha: 1,
            delay: 200,
            duration: 200,
        })

        titre1.x -=50
        this.tweens.add({
            targets: titre1,
            alpha: 1,
            x: titre1.x + 50,
            delay: 400,
            duration: 400,
        })

        titre2.x +=50
        this.tweens.add({
            targets: titre2,
            alpha: 1,
            x: titre2.x - 50,
            delay: 800,
            duration: 400,
        })

        this.time.addEvent({
            delay: 1000,
            callback: () => {
                this.addPopUp()
            }
        })

    }

    addPopUp(){

        this.popupAide = new PopUpBlue(this, this.width/2, 818, 755, 470)
        this.popupAide.depth = 1001

        const txt ="Enfin à Genève ! Derrière les vitrines de montres et de chocolats, c’est surtout la docteure Cercis que je cherche.\nJ’ai hâte de l'entendre s'exprimer lors de sa conférence ; il faut que je comprenne son lien avec ce mystérieux laboratoire."
        let textElmt = this.add.rexTagText(0, 0, txt, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '28px',
            color: Colors.Text.White,
            align: 'center',
            wordWrap: { width: 650 },
            lineSpacing: 8,
            tags: tags
        }).setOrigin(0.5, 0)

        this.popupAide.addElementToBody(textElmt, 40)

        let button = new ButtonRounded(this, 0, 0, {
            text: "Démarrer le chapitre 5",
            color: Colors.Elmt.White,
            borderColor: Colors.Elmt.White,
            borderHoverColor: Colors.Elmt.Blue,
            textColor: Colors.Text.Black,
            textHoverColor: Colors.Text.Blue
        })
        this.popupAide.addElementToBody(button, 40 + button.height/2 )
        button.setClickFunction( () => {
            this.popupAide.animOut(() => {
                this.scene.start("Chapitre5_0")
            })
            this.tweens.add({
                targets: this.introGroup.getChildren(),
                alpha: 0,
                duration: 500,
            })
        })

        this.popupAide.animIn()
    }

}